import crossSellCards from '/source/_patterns/01-components/product/partials/crossSellCards.hbs';
import { loadSpinner, stopSpinner } from '/source/_patterns/01-components/spinner/spinner';
import * as cartService from '/source/js/services/cartService';
import * as inventoryService from '/source/js/services/inventoryService';
import * as toastUtil from '/source/js/utils/toastUtil';
import { announceAddedToCart } from '/source/js/utils/announceUtil';
import { hideCartModalShoppingContext } from '/source/_patterns/01-components/cart-ribbon/cart-ribbon';

let crossSellData;

function addToCartFailed(result) {
    let msg = '';
    if(result.Messages) {
        let msgo = result.Messages.find(msg => msg.DisplayMessage === true);
        if(!msgo) msgo = result.Messages[0];
        if(msgo) msg = msgo.MessageText;
    }
    if(result.ErrorCode && result.Message) msg = result.Message;
    showErrorMessage(msg);
}

function showErrorMessage(text) {
    toastUtil.Error(text);
    console.error(text);
}

export async function addCrossSellProductToCart(selectedProduct) {
    let quantity = 1;
    loadSpinner();

    let cleanUrl = selectedProduct.Url;
    if(selectedProduct.Url.indexOf('?') > 0) {
        cleanUrl = cleanUrl.substring(0, cleanUrl.indexOf('?'));
    }

    try {
        let result;
        if(selectedProduct.IsKit === true) {
            result = await cartService.addKitToCart({
                FamilyId: selectedProduct.FamilyId,
                FamilyName: selectedProduct.Name,
                ProductId: `Isagenix_Master|${selectedProduct.Id}|`,
                Quantity: quantity,
                ProductPageRelativeUrl: cleanUrl,
                PriceType: selectedProduct.DefaultPriceType,
                Sku: selectedProduct.Sku,
                TryOnce: false,
                IsCrossSell: true
            });
        } else {
            result = await cartService.addToCart({
                FamilyId: selectedProduct.FamilyId,
                FamilyName: selectedProduct.Name,
                ProductId: `Isagenix_Master|${selectedProduct.Id}|`,
                Quantity: quantity,
                ProductPageRelativeUrl: cleanUrl,
                PriceType: selectedProduct.DefaultPriceType,
                TryOnce: false,
                IsCrossSell: true
            });
        }
        if(result.IsSuccessful) {
            stopSpinner();
            cartService.updateQSForMergeCart();
            hideCartModalShoppingContext(selectedProduct.DefaultPriceType);
            updateSubHeader(result);
        } else {
            stopSpinner();
            console.error(result);
            addToCartFailed(result);
        }
    } catch (ex) {
        console.error(ex);
        stopSpinner();
    }
}

export function crossSellAddProduct() {
    let $itemAddedToCart = $('#ItemAddedToCart').val();
    let $crossSellCard = $(this).closest('.isa-modal__product');
    let $crossSellProductId = $(this).attr('id');
    let crossSellselectedProduct = crossSellData.filter(item => item.Id === $crossSellProductId)[0];

    $crossSellCard.prepend(`<div class="card-selected">
    <i class="fal fa-circle-check icon-circle-check-whiteBG mr-md"></i>
    <h4>${$itemAddedToCart}</h4></div>`);
    addCrossSellProductToCart(crossSellselectedProduct);
}

export function crossSellAddPack() {
    let $href = $(this).siblings('.crossSell-anchor').attr('href');
    $href = $href + '&open=1&iscrosssell=1';
    window.location.href = $href;
}

export function updateCrossSellCards(result) {
    let $modalSubheader = ('#crossSellSubHeader');
    $($modalSubheader).html('');
    let $youMightAlsoEnjoy = $('#YouMightAlsoEnjoy').val();

    if(result.CrossSellProducts && result.CrossSellProducts.length) {
        crossSellData = result.CrossSellProducts;
        console.log(crossSellData);
        let $crossSellResult = {
            products: result.CrossSellProducts,
            isTaxInclusive: result.IsTaxInclusive,
            labels: {
                unavailable: $('#Unavailable').val(),
                buildMyPack: $('#BuildMyPack').val(),
                addToCart: $('#AddToCart').val(),
                taxInclusivePriceText: $('#hdnTaxInclusiveText').val()
            }
        };

        $($modalSubheader).html($youMightAlsoEnjoy);
        let $modalBlock = $('.cross-sell-modal');
        let $crossSellProducts = crossSellCards($crossSellResult);
        $modalBlock.empty().append($crossSellProducts);

        result.CrossSellProducts.forEach(function (product) {
            if(product && product.IsCheckStock) {
                checkCrossSellStock(product.Id);
            }
        });
    }
}

export async function checkCrossSellStock(productId) {
    let $unavailable = $('#Unavailable').val();
    let idsToCheck = [productId];
    var response = await inventoryService.getUnavailableInventory(idsToCheck);
    if(response && response.length > 0) {
        $('#' + productId).find('.buttonCrossSell').addClass('card-button-disable').attr('disabled', 'disabled').text($unavailable);
        $('#' + productId).find('.buttonCrossSell').removeClass('crossSellAddProduct');
    }
}

export function updateSubHeader(result) {
    let itemCount = result.QuantityTotal || result.TotalItemCount;
    let productName = result.Name || result.ProductName || '';
    $('.header__cart-items').removeClass('d-none').text(itemCount);
    announceAddedToCart(productName, itemCount);
    let $subHeader = $('.isa-modal__cart .card-subheader');
    if(!$subHeader.length) {
        return;
    }
    let subtitle = $subHeader.data('title');
    subtitle = subtitle.replace('###', itemCount);
    $subHeader.empty().append(subtitle);
}
